import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'react-fa';
import { Link } from 'react-router-dom';
import AddButton from '../components/buttons/AddButton';
import { withTheme } from 'styled-components'

class NxtButton extends React.Component {

  render() {
    const { onClick, to, disabled } = this.props;

    if (onClick) {
      return <AddButton disabled={disabled} onClick={onClick} title="Próxima etapa" />;
    }

    return (
      <Link to={to}>
        <button className="sc-AxiKw coUCbo btn mb-3 ml-3" style={{ backgroundColor: this.props.theme.primary, color: "#ffffff" }}><Icon name="chevron-right"></Icon></button>
      </Link>
    );
  }
};

NxtButton.propTypes = {
  to: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

NxtButton.defaultProps = {
  onClick: null,
  disabled: false,
  to: '/',
};

export default withTheme(NxtButton);
